import React from "react";
import { QRCodeSVG } from "qrcode.react";

interface QRCodeProps {
  value: string;
  size: number;
  bgColor?: string;
  fgColor?: string;
  level?: "L" | "M" | "Q" | "H";
}

const QRCodeWithLogo: React.FC<QRCodeProps> = ({
  value,
  size,
  bgColor = "#FFF",
  fgColor = "#212121",
  level = "M",
}) => {
  if (!value) return null;
  return (
    <QRCodeSVG
      value={value}
      fgColor={fgColor}
      bgColor={bgColor}
      size={size}
      level={level}
    />
  );
};

export default QRCodeWithLogo;
